/* Vitgem — article table of contents.
   Builds an "On this page" nav from the article body's top-level H2s.
   Hidden when there are fewer than 3 headings. No dependencies. */
(function () {
  function slugify(s) {
    return s.toLowerCase().trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .slice(0, 60) || 'section';
  }

  function build() {
    var mount = document.getElementById('vg-toc');
    var body = document.querySelector('.vg-article-body');
    if (!mount || !body) return;

    // Top-level prose headings only — skip those inside References / Related boxes.
    var headings = Array.prototype.filter.call(
      body.querySelectorAll('h2'),
      function (h) { return !h.closest('.vg-refs, .vg-related, .vg-toc'); }
    );
    if (headings.length < 3) return;

    var used = {};
    var ol = document.createElement('ol');
    headings.forEach(function (h) {
      var id = h.id;
      if (!id) {
        id = slugify(h.textContent);
        while (used[id] || document.getElementById(id)) { id = id + '-x'; }
        h.id = id;
      }
      used[id] = true;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      ol.appendChild(li);
    });

    var nav = document.createElement('nav');
    nav.className = 'vg-toc';
    nav.setAttribute('aria-label', 'On this page');
    var title = document.createElement('p');
    title.className = 'vg-toc-title';
    title.textContent = 'On this page';
    nav.appendChild(title);
    nav.appendChild(ol);
    mount.replaceWith(nav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();

/* Vitgem — article audio narration player.
   Progressively enhances #vg-audio (data-src = MP3 URL, data-duration = seconds)
   into a player: play/pause, draggable seek bar with a visible thumb, time, speed (max 1.5x).
   Audio is preload="none" — nothing loads until the first play (LCP-safe).
   No dependencies. ES5. */
(function () {
  var SPEEDS = [1, 1.25, 1.5];

  function fmt(t) {
    if (!isFinite(t) || t < 0) t = 0;
    t = Math.floor(t);
    var m = Math.floor(t / 60), s = t % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function el(tag, cls, attrs) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (attrs) for (var k in attrs) { if (attrs.hasOwnProperty(k)) n.setAttribute(k, attrs[k]); }
    return n;
  }

  function build() {
    var mount = document.getElementById('vg-audio');
    if (!mount) return;
    var src = mount.getAttribute('data-src');
    if (!src) return;
    var presetDur = parseFloat(mount.getAttribute('data-duration')) || 0;

    var audio = new Audio();
    audio.preload = 'none';
    audio.src = src;

    // --- UI ---------------------------------------------------------------
    var wrap = el('div', 'vg-audio', { 'role': 'group', 'aria-label': 'Listen to this article' });

    var label = el('span', 'vg-audio-label');
    label.textContent = 'Listen to this article';

    var play = el('button', 'vg-audio-play', { 'type': 'button', 'aria-label': 'Play narration' });
    play.innerHTML = playIcon();

    var bar = el('div', 'vg-audio-bar', {
      'role': 'slider', 'tabindex': '0', 'aria-label': 'Seek',
      'aria-valuemin': '0', 'aria-valuemax': '100', 'aria-valuenow': '0'
    });
    var fill = el('div', 'vg-audio-fill');
    var thumb = el('div', 'vg-audio-thumb');     // visible position handle
    bar.appendChild(fill);
    bar.appendChild(thumb);

    var time = el('span', 'vg-audio-time');
    time.textContent = '0:00 / ' + (presetDur ? fmt(presetDur) : '0:00');

    var rate = el('button', 'vg-audio-rate', { 'type': 'button', 'aria-label': 'Playback speed' });
    var speedIdx = 0;
    rate.textContent = '1×';

    var controls = el('div', 'vg-audio-controls');
    controls.appendChild(play);

    var meta = el('div', 'vg-audio-meta');
    meta.appendChild(time);
    meta.appendChild(rate);

    // Hide button — only visible when docked; collapses the floating bottom bar.
    var close = el('button', 'vg-audio-close', { 'type': 'button', 'aria-label': 'Hide player' });
    close.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';

    wrap.appendChild(label);
    wrap.appendChild(controls);
    wrap.appendChild(bar);
    wrap.appendChild(meta);
    wrap.appendChild(close);

    // In-flow placeholder. When the player docks (position:fixed) the dock keeps
    // its height so the article below doesn't jump.
    var dock = el('div', 'vg-audio-dock');
    dock.appendChild(wrap);

    // Floating restore pill — shown after the user hides the docked bar so they can bring it back.
    var restore = el('button', 'vg-audio-restore', { 'type': 'button', 'aria-label': 'Play narration' });
    restore.innerHTML = '<svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>';
    dock.appendChild(restore);

    mount.replaceWith(dock);

    // --- behaviour --------------------------------------------------------
    function playIcon() { return '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>'; }
    function pauseIcon() { return '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="M6 5h4v14H6zM14 5h4v14h-4z" fill="currentColor"/></svg>'; }

    function dur() { return isFinite(audio.duration) && audio.duration > 0 ? audio.duration : presetDur; }

    function render() {
      var d = dur();
      var pct = d ? Math.min(100, (audio.currentTime / d) * 100) : 0;
      fill.style.width = pct + '%';
      thumb.style.left = pct + '%';
      bar.setAttribute('aria-valuenow', Math.round(pct));
      time.textContent = fmt(audio.currentTime) + ' / ' + fmt(d);
    }

    function toggle() {
      if (audio.paused) { audio.play(); } else { audio.pause(); }
    }

    play.addEventListener('click', toggle);
    audio.addEventListener('play', function () {
      play.innerHTML = pauseIcon();
      play.setAttribute('aria-label', 'Pause narration');
      wrap.classList.add('is-playing');
    });
    audio.addEventListener('pause', function () {
      play.innerHTML = playIcon();
      play.setAttribute('aria-label', 'Play narration');
      wrap.classList.remove('is-playing');
    });
    audio.addEventListener('ended', function () { audio.currentTime = 0; render(); });
    audio.addEventListener('timeupdate', render);
    audio.addEventListener('loadedmetadata', render);

    rate.addEventListener('click', function () {
      speedIdx = (speedIdx + 1) % SPEEDS.length;
      audio.playbackRate = SPEEDS[speedIdx];
      rate.textContent = SPEEDS[speedIdx] + '×';
    });

    // Draggable seek — pointer events cover mouse + touch; the thumb tracks the position live.
    var dragging = false;
    function seekTo(clientX) {
      var rect = bar.getBoundingClientRect();
      var pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      audio.currentTime = pct * dur();
      render();
    }
    bar.addEventListener('pointerdown', function (e) {
      dragging = true;
      if (bar.setPointerCapture) { try { bar.setPointerCapture(e.pointerId); } catch (err) {} }
      wrap.classList.add('is-seeking');
      seekTo(e.clientX); e.preventDefault();
    });
    bar.addEventListener('pointermove', function (e) { if (dragging) { seekTo(e.clientX); } });
    function endDrag() { dragging = false; wrap.classList.remove('is-seeking'); }
    bar.addEventListener('pointerup', endDrag);
    bar.addEventListener('pointercancel', endDrag);
    bar.addEventListener('keydown', function (e) {
      var step = 5;
      if (e.key === 'ArrowRight') { audio.currentTime = Math.min(dur(), audio.currentTime + step); render(); e.preventDefault(); }
      else if (e.key === 'ArrowLeft') { audio.currentTime = Math.max(0, audio.currentTime - step); render(); e.preventDefault(); }
      else if (e.key === ' ' || e.key === 'Enter') { toggle(); e.preventDefault(); }
    });

    // Spotify-style docking: once the player scrolls above the viewport it can pin
    // to the bottom of the screen. By default the docked state is COLLAPSED — only a
    // small floating play button shows; tapping it expands the full bar (and plays).
    // The × on the full bar collapses it back to the floating button.
    var expanded = false, scrolledPast = false;
    function applyDock() {
      if (scrolledPast && expanded) {
        if (!wrap.classList.contains('is-docked')) {
          dock.style.minHeight = wrap.offsetHeight + 'px'; // reserve space before fixing
          wrap.classList.add('is-docked');
        }
        restore.classList.remove('is-on');
      } else {
        if (wrap.classList.contains('is-docked')) { wrap.classList.remove('is-docked'); dock.style.minHeight = ''; }
        restore.classList.toggle('is-on', scrolledPast && !expanded); // collapsed floating button
      }
    }
    close.addEventListener('click', function () { expanded = false; applyDock(); });   // collapse
    restore.addEventListener('click', function () {                                    // expand + play
      expanded = true; applyDock();
      if (audio.paused) { audio.play(); }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        scrolledPast = !e.isIntersecting && e.boundingClientRect.top < 0;
        if (!scrolledPast) expanded = false; // inline player back in view → reset to collapsed
        applyDock();
      }, { threshold: 0 });
      io.observe(dock);
    }

    // Reuse the SVG once the helpers are defined, and paint the initial 0% state
    // so the seek thumb is visible immediately (before the first timeupdate).
    play.innerHTML = playIcon();
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
